export function CountBranch(branchRootSC) {
  if (branchRootSC == null) return 0;

  var c = 1;
  var childCount = branchRootSC.ChildCount();
  for (var i = 0; i <= childCount; i++) {
    var aChild = branchRootSC.GetIndexChild(i);
    c = c + CountBranch(aChild);
  }

  return c;
}
